export enum BuyerRoutes {
  INDEX = ''
}
export default BuyerRoutes;
